const SETTINGS_KEY = 'ai-or-not:settings';

const defaultSettings = {
  haptics: true,
  autoplayVideo: true,
};

export function getSettings() {
  try {
    const storedSettings = window.localStorage.getItem(SETTINGS_KEY);

    return {
      ...defaultSettings,
      ...(storedSettings ? JSON.parse(storedSettings) : {}),
    };
  } catch {
    return defaultSettings;
  }
}

export function saveSettings(settings) {
  const nextSettings = {
    ...defaultSettings,
    ...settings,
  };

  window.localStorage.setItem(SETTINGS_KEY, JSON.stringify(nextSettings));

  return nextSettings;
}

export { SETTINGS_KEY };
